<template>
  <div :class="className">
    <a
      :aria-label="label"
      :title="label"
      :data-skip-tab-focus="!enabled"
      :aria-disabled="!enabled"
      :tabindex="enabled ? 0 : -1"
      :data-gtm="gtm"
      class="controls__link"
      href="#"
      role="button"
      @click.prevent="$emit('action')"
      v-html="svg"
      />
  </div>
</template>

<script>
  import { embedSVG } from 'Helpers/embedSVG';

  export default {
    props: {
      className: {type: String, required: true },
      label: {type: String, required: true },
      svgName: {type: String, required: true },
      svgClass: {type: String, required: true },
      enabled: {type: Boolean, required: true },
      focusOnMount: {type: Boolean, required: true },
      gtm: { type: String, required: true },
    },

    computed: {
      svg() {
        let svgClass = this.svgClass;
        if (!this.enabled) {
          svgClass = this.svgClass + " controls--inactive";
        }

        return embedSVG(this.svgName, svgClass);
      },

    },

    mounted() {
      if (this.focusOnMount){
        this.$el.querySelector("a").focus();
      }
    },

    methods: {
      todo() {
        //see if this can be shared with previous-next/controlLink
      }
    },
  };

</script>
